import { toast } from "sonner";
import { Switch } from "../ui/switch";
import { useApi } from "../../lib/useApi";
import { api, formatApiError } from "../../lib/api";

export default function CommunicationConsents() {
  const { data, reload } = useApi("/me/communications");
  const toggle = async (c) => {
    try { await api.put(`/me/communications/${c.company_id}`, { subscribed: c.status !== "subscribed" }); toast.success("Préférence enregistrée"); reload(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="card-surface p-5" data-testid="communication-consents">
      <p className="font-display font-semibold">Communications des organisations</p>
      <p className="mt-1 text-sm text-slate-500">Organisations auxquelles vous avez accepté de recevoir des emails d'information ou commerciaux. Les emails liés à vos dossiers ne sont pas concernés.</p>
      {!data?.length && <p className="mt-3 text-sm text-slate-400">Aucun consentement enregistré.</p>}
      <ul className="mt-3 divide-y">{(data || []).map((c) => (
        <li key={c.company_id} className="flex items-center justify-between py-2 text-sm"><span>{c.company_name}</span>
          <Switch checked={c.status === "subscribed"} onCheckedChange={() => toggle(c)} data-testid={`consent-${c.company_id}`} /></li>))}</ul>
    </div>
  );
}
